/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{LayerViewPerformanceInfo as s}from"./support/LayerViewPerformanceInfo.js";class e extends s{constructor(s,e,o,r,i){super(s,e,-1,o,r),this.queue=i}}class o{constructor(s,e,o,r){this.loading=s,this.indexLoading=e,this.processing=o,this.idleProcessing=r}}export{e as PointCloudLayerViewPerformanceInfo,o as QueuePerformanceInfo};
